import axios from '@/server/axios'


export function queryPrefixBanner() {
  return axios({
    url: 'officialWebsite/queryPrefixBanner.do',
    method: 'get',
  })
}